import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint';
import gsap from "gsap";

export default class SmarteProduktion extends THREE.Object3D {
    constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
        super();
        this.initPin(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor);
    }

    initPin(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
        this.pinModel10 = new Heatpoint(null, "model/heatointsmarteproduktion.glb");
        setTimeout(() => this.pinModel10.setColor(pinColor), 1000);
        
        this.pinModel10.position.set(-0.4, 0.40, 0.82);
        interactionManager.add(this.pinModel10);
        this.visited = false;

        this.pinModel10.addEventListener("click", () => this.handleClick(camera, onPinClick, gltfanimations, mixer, true));
        this.pinModel10.addEventListener('mouseover', () => this.handleMouseOver(pinColorDark));
        this.pinModel10.addEventListener('mouseout', () => this.handleMouseOut(pinColor, visitedPinColor));
        
        this.add(this.pinModel10);
        this.rotatePin();
    }

    handleClick(camera, onPinClick, gltfanimations, mixer, modal) {
        onPinClick();
        gsap.to(camera.position, { x: -0.4, y: 0.7, z: 1.8, duration: 2.5, ease: "Power3.inOut" });
        this.visited = true;
        this.triggerAnimations(gltfanimations, mixer, modal);
    }

    handleMouseOver(pinColorDark) {
        document.body.style.cursor = 'pointer';
        this.pinModel10.setColor(pinColorDark);
    }

    handleMouseOut(pinColor, visitedPinColor) {
        document.body.style.cursor = 'default';
        const color = this.visited ? visitedPinColor : pinColor;
        this.pinModel10.setColor(color);
    }

    triggerAnimations(gltfanimations, mixer, modal) {
        this.smarteproduktion = this.getClipAction(gltfanimations, mixer, 'Die ganze Stadt.013Action');
        this.smarteproduktion.stop();
        this.smarteproduktion.reset();
        this.smarteproduktion.timeScale = 1;
        this.smarteproduktion.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;

        if (modal) {
            setTimeout(() => {
                const modal10 = document.getElementById('modal10');
                modal10.classList.remove('hidden');
            }, 3000);

            const modal10 = document.getElementById('modal10');
            modal10.addEventListener('click', () => {
                modal10.classList.add('hidden');
                this.reverseAnimation();
            });
        }
    }

    getClipAction(gltfanimations, mixer, animationName) {
        const animationClip = THREE.AnimationClip.findByName(gltfanimations, animationName);
        return mixer.clipAction(animationClip);
    }

    reverseAnimation() {
        this.smarteproduktion.timeScale = -1;
        this.smarteproduktion.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
        this.smarteproduktion.reset();
    }

    resetAnimations(gltfanimations, mixer) {
        this.smarteproduktion = this.getClipAction(gltfanimations, mixer, 'Die ganze Stadt.013Action');
        this.smarteproduktion.stop();
        this.smarteproduktion.reset();
        this.smarteproduktion.timeScale = 1;
    }

    rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI,
            duration: 10,
            ease: "none",
            onUpdate: () => this.pinModel10.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle),
            repeat: -1
        });
    }
}
